// @ts-nocheck
import React, { useEffect, useRef, useId } from "react";

const FOCUSABLE =
  'a[href],button:not([disabled]),textarea:not([disabled]),input:not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])';

export function Modal({ title, children, onClose, wide, panelClassName }) {
  const panelRef = useRef(null);
  const titleId = useId();

  useEffect(() => {
    const previouslyFocused =
      typeof document !== "undefined" ? document.activeElement : null;
    const panel = panelRef.current;
    // Announce the dialog by moving focus onto the labelled panel.
    panel?.focus?.();

    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const onKeyDown = (e) => {
      if (e.key === "Escape") {
        e.stopPropagation();
        onClose?.();
        return;
      }
      if (e.key === "Tab" && panel) {
        const items = panel.querySelectorAll(FOCUSABLE);
        if (!items.length) {
          e.preventDefault();
          panel.focus();
          return;
        }
        const first = items[0];
        const last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    };
    document.addEventListener("keydown", onKeyDown, true);
    return () => {
      document.removeEventListener("keydown", onKeyDown, true);
      document.body.style.overflow = prevOverflow;
      // Return focus to whatever opened the dialog.
      if (previouslyFocused && previouslyFocused.focus) previouslyFocused.focus();
    };
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 bg-black/60 z-50 flex items-end sm:items-center justify-center p-0 sm:p-4 safe-x"
      onClick={onClose}
    >
      <div
        ref={panelRef}
        role="dialog"
        aria-modal="true"
        aria-labelledby={title ? titleId : undefined}
        tabIndex={-1}
        className={`bg-white shadow-2xl w-full ${wide ? "max-w-2xl" : "max-w-md"} max-h-[90dvh] sm:max-h-[85dvh] overflow-y-auto hide-scrollbar motion-safe:animate-scaleIn focus:outline-none rounded-t-2xl sm:rounded-2xl safe-bottom ${panelClassName || ""}`}
        onClick={e => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-4 sm:px-6 py-3 sm:py-4 border-b border-line sticky top-0 bg-white z-10 safe-top">
          <h2 id={titleId} className="font-bold text-ink-900 pr-2">{title}</h2>
          {onClose && (
            <button
              type="button"
              onClick={onClose}
              aria-label="Close dialog"
              className="text-ink-400 hover:text-ink-600 w-10 h-10 rounded-full hover:bg-slate-100 flex items-center justify-center focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-600 shrink-0"
            >
              ✕
            </button>
          )}
        </div>
        <div className="p-4 sm:p-6">{children}</div>
      </div>
    </div>
  );
}
